type Args = {
  slug: string;
  accountId: string;
};

const generateStandaloneDeepLink = ({ accountId, slug }: Args): string =>
  `https://use.bndl.nl/-/${accountId}/s/apps/${slug}`;

export default generateStandaloneDeepLink;
